import { z } from "zod";
import { USER_ROLES } from "@/config/demoAuth.config";

export const demoLoginSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(1, "Password is required"),
});

export type DemoLoginFormValues = z.infer<typeof demoLoginSchema>;

export const demoSignUpSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  role: z.enum(USER_ROLES, { errorMap: () => ({ message: "Please select a role" }) }),
  organization: z.string().trim().min(1, "This field is required"),
  accessCode: z.string().trim().min(1, "Access code is required"),
});

export type DemoSignUpFormValues = z.infer<typeof demoSignUpSchema>;
